import { buildPublicPath } from '@hen-site/utils/buildPublicPath';

/** Posts per page on leaf category hub pages (matches section preview size). */
export const CATEGORY_HUB_PAGE_SIZE = 9;

export const CATEGORY_HUB_PAGE_PARAM = 'page';

export function parseCategoryHubPage(
  searchParams: Record<string, string | string[] | undefined>,
): number {
  const raw = searchParams[CATEGORY_HUB_PAGE_PARAM];
  const value = Array.isArray(raw) ? raw[0] : raw;
  if (!value) return 1;
  const parsed = Number.parseInt(value, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
}

/** Public category hub path, tenant-prefixed only when the host requires it. */
export function buildCategoryHubPageUrl(
  tenant: string,
  slug: string,
  page: number,
  browserHost?: string | null,
): string {
  const base = buildPublicPath(tenant, `/${slug}/`, browserHost);
  if (page <= 1) return base;
  return `${base}?${CATEGORY_HUB_PAGE_PARAM}=${page}`;
}

function getTotalPages(totalItems: number, pageSize: number): number {
  if (totalItems <= 0 || pageSize <= 0) return 0;
  return Math.ceil(totalItems / pageSize);
}

function clampPage(page: number, totalPages: number): number {
  if (totalPages <= 0) return 1;
  return Math.min(Math.max(1, page), totalPages);
}

export function sliceCategoryHubPosts<T>(
  posts: readonly T[],
  page: number,
  pageSize: number = CATEGORY_HUB_PAGE_SIZE,
): {
  posts: T[];
  currentPage: number;
  totalPages: number;
} {
  const totalPages = getTotalPages(posts.length, pageSize);
  const currentPage = clampPage(page, totalPages);
  const start = (currentPage - 1) * pageSize;
  return {
    posts: posts.slice(start, start + pageSize),
    currentPage,
    totalPages,
  };
}
